<template>
  <div :class="classModifiers">
    <template v-if="hasServerMessage">
      <div
        v-if="maintenance.suspendedMessage"
        class="app-header-notification app-header-notification--with-close app-header-notification--not-clickable"
      >
        <div class="app-header-notification__content" v-html="maintenanceMessageText"></div>
      </div>
      <div
        v-else-if="maintenance.systemMessage"
        class="app-header-notification app-header-notification--with-close app-header-notification--system"
        @click.stop="onSystemMessageClick"
      >
        <div class="app-header-notification__content">
          <div v-html="maintenanceMessageText"></div>
          <div
            class="app-header-notification__close"
            @click.prevent.stop="onCloseMaintenanceMessage"
          >
            <div class="app-header-notification__close-icon"></div>
          </div>
        </div>
      </div>
    </template>
    <div
      v-else-if="liveUpdatesDisabled"
      @click.stop="onErrorClick"
      class="app-header-notification app-header-notification--system"
    >
      <div class="app-header-notification__content">
        Due to page inactivity, live updates, including account balance, have been disabled on this
        page. To re-enable live updates please refresh the page.
      </div>
    </div>
    <div
      v-else-if="showErrorNotification"
      @click.stop="onErrorClick"
      class="app-header-notification"
    >
      <div class="app-header-notification__content">
        An error has occurred. Click&nbsp;<a class="app-header-notification__link" href="#">here</a
        >&nbsp;to reload the page.
      </div>
    </div>
  </div>
</template>
<script src="./app-header-notification.js"></script>
<style src="./app-header-notification.scss" lang="scss"></style>
